export default __webpack_public_path__ + "static/media/1.d6d37a9c.jpg";